import React from 'react';
import { ZENDESK_URL_GUIDE } from '../utilities/constants';
import { HelpMenu } from './HelpMenu';
import { GuideIcon } from './icons/GuideIcon';

export const MasterPageHeader = props => {
  return <PageHeader disableHelpMenu={false} {...props} />;
};

export const ConferencePageHeader = props => {
  return <PageHeader {...props} />;
};
export const EntrancePageHeader = props => {
  return <PageHeader {...props} />;
};

const PageHeader = ({
  leftComponent,
  rightComponent,
  middleComponent,
  title,
  onClose,
  loaded = true,
  loaderComponent = null,
  dataTestId = null,
  disableHelpMenu = true,
}) => {
  const hasLoader = !!loaderComponent;
  const isLoading = hasLoader && !loaded;
  const testId = {
    root: dataTestId,
    title: `${dataTestId}_title`,
  };
  const handleShowGuide = () => {
    window.open(ZENDESK_URL_GUIDE.FIRST_GUIDE, '_blank');
  };
  return (
    <div className='PageHeader' data-testid={dataTestId && testId.root}>
      {isLoading && <div>{loaderComponent}</div>}
      <div className='PageHeader__left-items'>
        <ChildrenComponent
          className='PageHeader__title'
          isLoading={isLoading}
          component={title}
          role='heading'
          dataTestId={dataTestId && testId.title}
        />
        <ChildrenComponent
          className='PageHeader__left-component'
          isLoading={isLoading}
          component={leftComponent}
        />
      </div>
      <div className='PageHeader__middle-items'>
        <ChildrenComponent
          isLoading={isLoading}
          component={middleComponent}
        />
      </div>
      <div className='PageHeader__right-items'>
        {!disableHelpMenu && (
          <React.Fragment>
            {!isLoading && (
              <button
                className='btn-help first-guide'
                onClick={handleShowGuide}
              >
                <GuideIcon className='icon--guide' />
                <span className='btn-help__text'>はじめてガイド</span>
              </button>
            )}

            <ChildrenComponent
              className='PageHeader__right-component'
              isLoading={isLoading}
              component={<HelpMenu />}
            />
          </React.Fragment>
        )}
        <ChildrenComponent
          className='PageHeader__right-component'
          isLoading={isLoading}
          component={rightComponent}
        />
        {onClose && (
          <PageHeaderCloseBtn
            className='PageHeaderCloseBtn'
            onClose={onClose}
          />
        )}
      </div>
    </div>
  );
};

const ChildrenComponent = ({
  component,
  className,
  isLoading = false,
  dataTestId = null,
  ...props
}) => {
  return component && !isLoading ? (
    <div
      className={className}
      {...props}
      data-testid={dataTestId && dataTestId}
    >
      {component}
    </div>
  ) : null;
};

const PageHeaderCloseBtn = props => {
  const { onClose, className } = props;
  const classes = className;

  return (
    <button onClick={onClose} className={classes}>
      <span className='PageHeaderCloseBtn__close-text'>閉じる</span>
      <i className='i-close__header i-2_4x' />
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageHeader.jsx